import { BoardComponent } from "src/app/pages/board/board.component";
import { Address } from "./address.model";
import { Game } from "./game.model";
import { RenewalMetric } from "./renewalMetric.model";
import { SalesRep } from "./sales-rep.model";
import { Board } from "./board.model";
import { DateInput } from "@fullcalendar/core";

export class Location{
   
    id: string;
    locationTag: string;
    locationName: string;
    businessAddress: Address;
    salesOutlet: boolean | number;
    /** Optional override for the default sales-outlet board price */
    salesOutletBoardPrice?: number;
    /** Whether the sales-outlet board order has been paid */
    salesOutletPaid?: boolean | number | string;
    /** How much has been paid toward the sales-outlet order */
    salesOutletPaidAmount?: number;
    enabled: boolean | number;
    board: Board;
    //cabinet: Cabinet;
    salesRep: SalesRep;
    locationStartDate: string;
    locationEndDate: string;
    numBoards: number
    numCabinets: number

    
}
